import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
const CHECKOUT_URL = 'https://axe-ia-tech.impultienda.ar/checkout';
export function FooterCTA() {
  return <section className="py-20 bg-white border-t border-slate-100" data-id="element-79">
      <div className="max-w-3xl mx-auto px-4" data-id="element-80">
        <div className="text-center mb-12" data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-82">
            🏁 CIERRE FINAL
          </h2>
          <p className="text-xl text-slate-600" data-id="element-83">
            Dale un giro a tu publicidad: creá tus campañas con IA y publicá más
            rápido.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-84">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 translate-x-1/2 -translate-y-1/2" data-id="element-85"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 -translate-x-1/2 translate-y-1/2" data-id="element-86"></div>

          <div className="relative z-10" data-id="element-87">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8 border-b border-white/10 pb-8" data-id="element-88">
              <div data-id="element-89">
                <h3 className="text-2xl font-bold mb-2" data-id="element-90">Axe IA Tech</h3>
                <p className="text-slate-300" data-id="element-91">Incluye 5 bonos gratis</p>
              </div>
              <div className="text-right" data-id="element-92">
                <div className="text-slate-400 line-through text-xl mb-1" data-id="element-93">
                  USD 242
                </div>
                <div className="text-5xl font-black text-blue-400" data-id="element-94">USD 17</div>
              </div>
            </div>

            <motion.a href={CHECKOUT_URL} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-r from-blue-500 to-indigo-500 text-white text-center font-bold text-xl py-5 rounded-xl shadow-lg shadow-blue-500/25 hover:from-blue-400 hover:to-indigo-400 transition-all mb-6" data-id="element-95">
              COMPRAR AHORA Y ACTIVAR ACCESO
            </motion.a>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400 font-medium" data-id="element-96">
              <div className="flex items-center gap-2" data-id="element-97">
                <Lock className="w-4 h-4" data-id="element-98" /> Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-99">
                <Zap className="w-4 h-4" data-id="element-100" /> Acceso inmediato
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mt-16 text-center text-slate-500 text-sm" data-id="element-101">
          <p data-id="element-102">© 2026 Axe IA Tech. Todos los derechos reservados.</p>
          <div className="flex items-center justify-center gap-4 mt-4" data-id="element-103">
            <a href="#" className="hover:text-slate-800 transition-colors" data-id="element-104">
              Términos y condiciones
            </a>
            <a href="#" className="hover:text-slate-800 transition-colors" data-id="element-105">
              Política de privacidad
            </a>
          </div>
        </div>
      </div>
    </section>;
}